import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { CLAN_RECRUITING_STATUS } from '../../metadata/fields.js';
import { getClanSearch } from '../../client/api/server_api.js';

const STRINGS = {
    ALL_RECRUITING: gettext("All Recruiting"),
    RECRUITING: gettext("Recruiting"),
    CLAN_RATING: gettext("Regiment Rating"),
    NAME: gettext("Regiment Name"),
    CLAN_TAG_OR_NAME: gettext("Enter Regiment Tag or Name"),
    SELECT_RECRUITMENT_STATUS: gettext("Select Recruitment Status"),
}

const ClanSearchModal = ({ isOpen, onClose }) => {
    const [query, setQuery] = useState('');
    const [recruitingType, setRecruitingType] = useState('all');
    const [searchResults, setSearchResults] = useState([]);
    const modalRef = useRef(null);

    useEffect(() => {
        if(query.length > 1) {
            Promise.all([getClanSearch(query)])
            .then(results => {
                setSearchResults(results[0].data);
            })
            .catch((err) => {
                console.log(err);
            })
        } else {
            setSearchResults([]);
        }
    }, [query]);

    if (!isOpen) return null;

    const handleQueryChange = (event) => {
        setQuery(event.target.value);
    };

    const handleRecruitingTypeChange = (event) => {
        setRecruitingType(event.target.value);
    };

    const handleModalClick = (event) => {
       if(!modalRef.current.contains(event.target)) {
           onClose();
       }
    };

    return(
        <div className="clanleaderboard_modal" onClick={handleModalClick}>
        <div className="clanleaderboard_modal_background" ref={modalRef}>
            <section>
            <div className="clanleaderboard_spread_contents">
            <div>
                <h2>{STRINGS.CLAN_TAG_OR_NAME}</h2>
                <input
                    type="text"
                    value={query}
                    onChange={handleQueryChange}/>
            </div>
            <div>
                <h2>{STRINGS.SELECT_RECRUITMENT_STATUS}</h2>
                <select onChange={handleRecruitingTypeChange}>
                    <option value="all">{STRINGS.ALL_RECRUITING}</option>
                    <option value="restricted">{CLAN_RECRUITING_STATUS['restricted']}</option>
                    <option value="closed">{CLAN_RECRUITING_STATUS['closed']}</option>
                    <option value="open">{CLAN_RECRUITING_STATUS['open']}</option>
                </select>
            </div>
            </div>
            </section>
            <table>
                <thead>
                    <tr>
                        <th>{STRINGS.NAME}</th>
                        <th>{STRINGS.RECRUITING}</th>
                        <th>{STRINGS.CLAN_RATING}</th>
                    </tr>
                </thead>
                <tbody>
                    {searchResults['results'] && searchResults['results'].length > 0 ? searchResults['results'].filter(x => recruitingType === 'all' || x.game_data.recruiting_policy === recruitingType).map(clan => (
                        <tr key={clan.id}>
                            <td>
                                <Link to={`/${window.LOCALE}/clanleaderboard/clan/${clan['id']}`} onClick={onClose}>
                                    <span>{clan.name}</span>&nbsp;
                                    <span className="orange-text tag">[{clan.tag}]</span>
                                </Link>
                            </td>
                            <td><span>{CLAN_RECRUITING_STATUS[clan.game_data.recruiting_policy]}</span></td>
                            <td><span>{clan.avg_rating ?? '-'}</span></td>
                        </tr>
                        )) : null
                    }
                </tbody>
            </table>
        </div>
        </div>
    )
};

export default ClanSearchModal;
